export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "oauth_login_fail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OAuthログインに失敗しました"])}
    }
  })
}
